import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { readOrderCreationErrorFragment } from "./readOrderCreationError.fragment"

export function readOrderCreationError(
  resonseKey: FragmentOf<typeof readOrderCreationErrorFragment> | undefined,
) {
  const response = readFragment(readOrderCreationErrorFragment, resonseKey)
  if (response?.__typename !== "OrderCreationErrorResponse") {
    return undefined
  }
  return response.errors[0]
}
